<template>
  <div class="bg-beige1 p-6 font-Spectral text-base text-black2">
    <div>
      <div :class="['grid grid-cols-2 gap-4', { 'md:grid-cols-3': enablePcLayout }]">
        <div class="flex gap-4">
          <img class="h-6 w-6" src="@/assets/icon/location/gray.svg" />
          <p class="leading-3 md:text-base" :class="{ 'md:text-base': enablePcLayout }">
            {{ destinationTagName }}
          </p>
        </div>
        <div class="flex gap-4">
          <img class="h-6 w-6" src="@/assets/icon/clock.png" />
          <p :class="{ 'md:text-base': enablePcLayout }">
            {{ experience.experienceDuration?.value }}<span :class="['text-xs', { 'md:text-sm': enablePcLayout }]">{{ experience.experienceDuration?.unit }}</span>
          </p>
        </div>
        <div v-if="formattedPrice" class="flex gap-4">
          <img class="h-6 w-6" src="@/assets/icon/price.png" />
          <p class="leading-3 md:text-base" :class="{ 'md:text-base': enablePcLayout }">
            {{ formattedPrice }}
          </p>
        </div>
        <div class="flex gap-4">
          <img class="h-6 w-6" src="@/assets/icon/group.svg" />
          <p :class="{ 'md:text-base': enablePcLayout }">Private: {{ experience.minGuestsPerReservation }} - {{ experience.maxGuests }}</p>
        </div>
        <div class="flex gap-4">
          <img class="h-6 w-6" src="@/assets/icon/record_voice_over.svg" />
          <p class="text-sm md:text-base" :class="{ 'md:text-base': enablePcLayout }">{{ interpreterOptionText }}</p>
        </div>
        <div class="flex gap-4">
          <img class="h-6 w-6" src="@/assets/icon/event_available.svg" />
          <p class="text-sm md:text-base" :class="{ 'md:text-base': enablePcLayout }">{{ cancelPolicyText }}</p>
        </div>
      </div>
    </div>
    <div class="mx-auto w-full pt-6 md:max-w-96">
      <AtomsPrimaryButton :on-click="onClickViewMore">View more</AtomsPrimaryButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getWabunkaChargeTypeLabel } from '@/models/wabunka/wabunkaChargeType';
import type { WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';
import { interpreterOptionText as buildInterpreterOptionText } from '@/models/wabunka/wabunkaInterpreterOption';
import { displayPrice } from '@/wabunka-src/features/Experience';
import { cancelPolicyText as buildCancelPolicyText } from '@/wabunka-src/features/Experience/models/cancellationPolicyTrigger';
import { displayDestinationTagName } from '@/wabunka-src/features/Experience/models/wabunkaExperienceTag';

interface Props {
  experience: WabunkaExperienceViewModel;
  enablePcLayout: boolean; // trueの場合のみ、768px以上でPC用のレイアウトにする
}

const props = defineProps<Props>();

// Template内で呼び出すPlaceholder等（本来はModel内に格納しても良いのかもしれない）
const destinationTagName = computed<string>(() => displayDestinationTagName(props.experience.tags));
const interpreterOptionText = computed<string>(() => buildInterpreterOptionText(props.experience.isInterpreterNeeded, props.experience.interpreterOptions));
const cancelPolicyText = computed<string>(() => buildCancelPolicyText(props.experience.cancellationPolicyTrigger, props.experience.refundableCancellationDaysForGuest));
const chargeTypeLabel = ref('');

watchEffect(() => {
  if (props.experience.chargeType) {
    chargeTypeLabel.value = getWabunkaChargeTypeLabel(props.experience.chargeType);
  }
});

const onClickViewMore = () => {
  navigateTo(`/experiences/${props.experience.slug}/`);
};

const formattedPrice = computed(() => {
  return displayPrice(props.experience);
});
</script>
